module.exports = __webpack_public_path__ + "img/1483494287.7b3cf9b4.jpg";